import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetCompetitorsForLead as GetCompetitorsForLeadQuery,
    GetCompetitorsForLead_lead_competitors as Competitors,
    GetCompetitorsForLeadVariables,
} from 'nutshell-graphql-types';

import GET_COMPETITORS_FOR_LEAD from '../queries/get-competitors-for-lead.graphql';

export const useGetCompetitorsForLead = (
    leadId: string
): {
    competitors: Competitors | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<
        GetCompetitorsForLeadQuery,
        GetCompetitorsForLeadVariables
    >(GET_COMPETITORS_FOR_LEAD, {
        variables: {
            leadId,
        },
    });

    return {
        competitors: data && data.lead && data.lead.competitors,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
